module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-intl/gatsby-browser.js'),
      options: {"plugins":[],"path":"/home/bamboo2/bamboo-agent-home/xml-data/build-dir/165806083-170852353/src/locales","languages":["en"],"defaultLanguage":"en","redirect":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-smoothscroll/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-hubspot/gatsby-browser.js'),
      options: {"plugins":[],"respectDNT":true,"productionOnly":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["UA-103074393-3","AW-946371372"],"pluginConfig":{"head":true,"respectDNT":true}},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Socialie","short_name":"socialie","description":"","start_url":"/","background_color":"#FFFFFF","theme_color":"#FC2361","display":"browser","icon":"/home/bamboo2/bamboo-agent-home/xml-data/build-dir/165806083-170852353/src/images/socialie.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"0bf05d2789aeab28289cef8aba852032"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
